export const iconFontAwesomeNatureFeather = (
	<i className="fa-solid fa-feather"></i>
);
